import React from "react";
import { motion } from "framer-motion";
import {
  UserCheck, CalendarClock, Crown, Users, Globe2, Workflow, ClipboardList, Target, ArrowUpRight,
} from "lucide-react";
import { SectionLabel } from "./Shared";
import { SERVICES } from "../config/siteConfig";
import { stagger, fadeUp, viewportOnce } from "../lib/motion";

const ICONS = { UserCheck, CalendarClock, Crown, Users, Globe2, Workflow, ClipboardList, Target };

export const Services = () => (
  <section id="services" className="bg-[#111111] text-[#F7F7F5] py-24 md:py-36" data-testid="services-section">
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <div className="max-w-3xl mb-16">
        <SectionLabel dark>What We Do</SectionLabel>
        <h2 className="font-display text-4xl md:text-5xl lg:text-6xl leading-[1.03] tracking-tight">
          Workforce Solutions Built Around <span className="text-[#E03535]">Your Business.</span>
        </h2>
      </div>

      <motion.div
        variants={stagger}
        initial="hidden"
        whileInView="show"
        viewport={viewportOnce}
        className="grid sm:grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 border border-white/10 rounded-sm overflow-hidden"
      >
        {SERVICES.map((s) => {
          const Icon = ICONS[s.icon] || Target;
          return (
            <motion.div
              key={s.id}
              variants={fadeUp}
              data-testid={`service-card-${s.id}`}
              className="group relative bg-[#111111] p-8 hover:bg-[#1a1a1a] transition-colors duration-400 min-h-[260px] flex flex-col"
            >
              <div className="w-12 h-12 rounded-sm border border-white/15 flex items-center justify-center mb-6 group-hover:border-[#C62828] group-hover:bg-[#C62828] transition-all duration-400">
                <Icon size={22} strokeWidth={1.5} className="text-[#E03535] group-hover:text-white transition-colors" />
              </div>
              <h3 className="font-body font-600 text-xl mb-3">{s.title}</h3>
              <p className="font-body text-white/55 text-sm leading-relaxed flex-1">{s.desc}</p>
              <span className="mt-5 inline-flex items-center gap-1 overline text-[10px] text-white/60 group-hover:text-[#E03535] transition-colors">
                Learn More <ArrowUpRight size={13} />
              </span>
              <span className="absolute top-0 left-0 h-0.5 w-0 bg-[#C62828] group-hover:w-full transition-all duration-500" />
            </motion.div>
          );
        })}
      </motion.div>
    </div>
  </section>
);

export default Services;
